import React from "react";
import ViewContainer from "@chemaxon/terminus-client/ui/components/view-container/ViewContainer";
import ApplicationList from "@chemaxon/terminus-client/ui/components/applications/ApplicationList";
import Subheader from "@chemaxon/terminus-client/ui/components/subheader/Subheader";
import { Restricted } from "@chemaxon/terminus-client/ui/utils/Restricted";
import {
  PlatformDomainObjectType,
  PlatformPermission,
} from "@chemaxon/terminus-client/ui/models/Permission";

class ListApplicationsView extends React.Component {
  render() {
    return (
      <React.Fragment>
        <Restricted
          to={{
            platformDomainObjectType: PlatformDomainObjectType.APPLICATION,
            platformPermission: PlatformPermission.WRITE,
          }}
        >
          <Subheader title={"Applications"} />
          <ViewContainer id={"listApplicationsContainer"} sx={{ px: 0 }}>
            <ApplicationList />
          </ViewContainer>
        </Restricted>
      </React.Fragment>
    );
  }
}
export default ListApplicationsView;
